import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { reviewTaskReport } from "../../services/employeeApi.js";
import { toast } from "react-toastify";
import { validateForm } from "../../middleware/validatemyTaskReportForm.js";
import { FaStar } from "react-icons/fa";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";

const ApproveTaskReportForm = ({ ApproveRequestData, onSubmitButton }) => {
  const { t } = useTranslation();
  let history = useHistory();
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const queryClient = useQueryClient();
  const updateReportMutation = useMutation(async (newData) => {
    await reviewTaskReport(newData);
    queryClient.invalidateQueries("get-my-task-approval-requests");
  });
  const user = GetUserInfo();
  const manager_id = user.id;
  const [formData, setFormData] = useState({
    task_record_id: ApproveRequestData.id,
    status: "approved",
    manager_remark: "",
    rating: 0,
    manager_id: manager_id,
  });

  const handleUpdateReport = async (ApproveRequestData) => {
    try {
      setIsSubmitting(true);
      await updateReportMutation.mutateAsync(ApproveRequestData);
      toast.success("task reviwed successful", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
      history.push(`/task-approval-request`);
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    handleUpdateReport(formData);
  };
  const RejectRequest = (e) => {
    e.preventDefault();
    const updatedData = { ...formData, status: "rejected" };
    handleUpdateReport(updatedData);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleStarClick = (ratingValue) => {
    setFormData((prev) => ({
      ...prev,
      rating: ratingValue, // Always set to the clicked star value
    }));
  };

  return (
    <>
      {hasAccess(["administrator", "manager"], user.accessRole) ? (
        <Form onSubmit={handleSubmit}>
          <div className="col-md-12 mb-3">
            <Form.Label className="font-weight-bold text-muted">
              {t("name")} {ApproveRequestData.employee_first_name}{" "}
              {ApproveRequestData.employee_father_name}
            </Form.Label>
          </div>
          <div className="col-md-12 mb-3">
            <Form.Label className="font-weight-bold text-muted">
              {t("task_name")} {ApproveRequestData.task_title}
            </Form.Label>
          </div>
          <div className="col-md-12 mb-3">
            <Form.Label className="font-weight-bold text-muted">
              {t("date")} {ApproveRequestData.date}
            </Form.Label>
          </div>

          <div className="col-md-12 mb-3">
            <Form.Label className="font-weight-bold text-muted">
              {t("quantity")} {ApproveRequestData.quantity}
            </Form.Label>
          </div>
          <div className="col-md-12 mb-3">
            <Form.Label className="font-weight-bold text-muted">
              {t("amount_birr")} {ApproveRequestData.amount_birr}
            </Form.Label>
          </div>

          <div className="col-md-12 mb-3">
            <Form.Label className="font-weight-bold text-muted">
              {t("task_rating")}
            </Form.Label>
            <div>
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  size={25}
                  onClick={() => handleStarClick(star)}
                  color={formData.rating >= star ? "#ffc107" : "#e4e5e9"}
                  style={{ cursor: "pointer", marginRight: 5 }}
                />
              ))}
            </div>
          </div>
          <div className="col-md-12 mb-3">
            <Form.Label
              htmlFor="Text1"
              className="font-weight-bold text-muted "
            >
              {t("remark")}
            </Form.Label>
            <Form.Control
              as="textarea"
              id="horizontalTextarea"
              rows="3"
              value={formData.manager_remark}
              onChange={(e) => handleInputChange(e, "manager_remark")}
              placeholder="add your remark "
            ></Form.Control>
            {formerror ? (
              <p className="text-danger">
                Looks like something's missing! Please make sure to complete all
                required fields before submitting your report.
              </p>
            ) : (
              ""
            )}
          </div>
          <div className="d-flex mt-1">
            <div className="mb-1">
              <Button
                className="bt btn-danger"
                onClick={(e) => RejectRequest(e)}
              >
                {t("reject")}
              </Button>
            </div>
            <div className="col-md-6 mb-1">
              <Button
                className="bt btn-info"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Sending...</span>
                  </span>
                ) : (
                  t("approve")
                )}
              </Button>
            </div>
          </div>
        </Form>
      ) : (
        ""
      )}
    </>
  );
};

export default ApproveTaskReportForm;
